import { smsLogin,wxLogin } from '@/api/apis'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    user: {},
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.user = user
      console.warn(user,6998)
    },

  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const rememberMe = true;//有缓存  缓存Tocken时长看config
      console.log('****',userInfo)
      if(userInfo.iswx==true){
        console.log('wxlogin')
        return new Promise((resolve, reject) => {
          wxLogin(userInfo).then(res => {
            
            setToken(res.token, rememberMe)
            commit('SET_TOKEN', res.token)
            commit('SET_USER', res.user)
            resolve()
          }).catch(error => {
            reject(error)
          })
        })
      }else {
               console.log('smsLogin')

        return new Promise((resolve, reject) => {
          smsLogin(userInfo).then(res => {
            setToken(res.token, rememberMe)
            commit('SET_TOKEN', res.token)
            commit('SET_USER', res.user)
            resolve()
          }).catch(error => {
            reject(error)
          })
        })
      }

    },
    setimg({commit},user){
      commit('SET_USER', user)
    }
    // // 获取用户信息
    // GetInfo({ commit }) {
    //   return new Promise((resolve, reject) => {
    //     getInfo().then(res => {
    //       setUserInfo(res, commit)
    //       resolve(res)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    // // 登出
    // LogOut({ commit }) {
    //   return new Promise((resolve, reject) => {
    //     logout().then(res => {
    //       logOut(commit)
    //       resolve()
    //     }).catch(error => {
    //       logOut(commit)
    //       reject(error)
    //     })
    //   })
    // },

  }
}

export const logOut = (commit) => {
  commit('SET_TOKEN', '')
  removeToken()
}


export default user
